import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import '../styles/Funcionarios.css';
import { FaHome, FaBox, FaUserPlus, FaTags, FaChevronLeft, FaChevronRight, FaGlobe, FaTasks, FaChartBar, FaUsers } from 'react-icons/fa';
import axios from 'axios';
import logo from '../assets/images/logo-nova.png';

const Funcionarios = () => {
  const [menuAberto, setMenuAberto] = useState(true);
  const [totalProdutos, setTotalProdutos] = useState(0);
  const [totalFuncionarios, setTotalFuncionarios] = useState(0);
  const [estoqueCritico, setEstoqueCritico] = useState(0);
  const [pedidosPendentes, setPedidosPendentes] = useState([]); // Lista de pedidos pendentes
  const nomeFuncionario = localStorage.getItem('username') || "Funcionário";
  const location = useLocation();

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  const isAreaInicial = location.pathname === '/funcionarios';

  const fetchTotalProdutos = async () => {
    try {
      const response = await axios.get('https://crmesquita.com.br/api/produtos/');
      setTotalProdutos(response.data.length);
      const critico = response.data.filter((produto) => produto.estoque <= 1).length;
      setEstoqueCritico(critico);
    } catch (error) {
      console.error('Erro ao buscar o total de produtos:', error);
    }
  };

  const fetchTotalFuncionarios = async () => {
    try {
      const response = await axios.get('https://crmesquita.com.br/api/funcionarios/');
      const staffCount = response.data.filter((user) => user.is_staff).length;
      setTotalFuncionarios(staffCount);
    } catch (error) {
      console.error('Erro ao buscar o total de funcionários:', error);
    }
  };

  const fetchPedidosPendentes = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://crmesquita.com.br/api/pedidos/pendentes/', {
        headers: { Authorization: `Token ${token}` },
      });
      setPedidosPendentes(response.data);
    } catch (error) {
      console.error('Erro ao buscar pedidos pendentes:', error);
    }
  };

  const finalizarPedido = async (pedidoId, codigo) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.patch(
        `https://crmesquita.com.br/api/pedidos/${pedidoId}/finalizar/`,
        { codigo },
        {
          headers: { Authorization: `Token ${token}` },
        }
      );

      alert(`Pedido ${pedidoId} finalizado com sucesso!`);
      // Atualizar a lista de pedidos pendentes
      setPedidosPendentes((prev) => prev.filter((pedido) => pedido.id !== pedidoId));
    } catch (error) {
      console.error('Erro ao finalizar o pedido:', error);
      alert('Código incorreto ou erro ao finalizar o pedido.');
    }
  };

  useEffect(() => {
    fetchTotalProdutos();
    fetchTotalFuncionarios();
    fetchPedidosPendentes(); // Buscar pedidos pendentes
  }, []);

  // Dados do menu
  const menuItems = [
    { to: "/", icon: <FaGlobe />, label: "Home do Site" },
    { to: "/funcionarios", icon: <FaHome />, label: "Área Inicial" },
    { to: "/funcionarios/gerenciar-produtos", icon: <FaBox />, label: "Gerenciar Produtos" },
    { to: "/funcionarios/cadastrar-funcionario", icon: <FaUserPlus />, label: "Cadastrar Funcionário" },
    { to: "/funcionarios/adicionar-marca-produto", icon: <FaTags />, label: "Adicionar Marca e Produto" },
    { to: "/funcionarios/gerenciar-usuarios", icon: <FaUsers />, label: "Gerenciar Usuários" } // Novo item
];

  return (
    <div className="funcionarios-container">
      {/* Menu lateral */}
      <aside className={`sidebar ${menuAberto ? 'aberto' : 'fechado'}`}>
        <div className="sidebar-header">
          <img
            src={logo}
            alt="Logo da Empresa"
            className="logo"
          />
          <button className="toggle-menu" onClick={toggleMenu}>
            {menuAberto ? <FaChevronLeft /> : <FaChevronRight />}
          </button>
        </div>
        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className={location.pathname === item.to ? 'active' : ''}>
                {item.icon}
                {menuAberto && <span>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

   
      <main className="main-content">
        <div className="content-header">
          <h1>
            Bem-vindo, <span className="nome-funcionario">{nomeFuncionario}</span>
          </h1>
          <p>Gerencie produtos e cadastre novos funcionários com facilidade.</p>
        </div>

       
        {isAreaInicial && (
          <>
            {/* Painel de Resumo */}
            <div className="dashboard-summary">
              <div className="summary-card">
                <FaBox className="summary-icon" />
                <h3>Total de Produtos</h3>
                <p>{totalProdutos}</p>
              </div>
              <div className="summary-card">
                <FaUserPlus className="summary-icon" />
                <h3>Total de Funcionários</h3>
                <p>{totalFuncionarios}</p>
              </div>
              <div className="summary-card">
                <FaTasks className="summary-icon" />
                <h3>Pedidos Pendentes</h3>
                <p>{pedidosPendentes.length}</p>
              </div>
              <div className="summary-card">
                <FaChartBar className="summary-icon" />
                <h3>Estoque Crítico</h3>
                <p>{estoqueCritico} produtos</p>
              </div>
            </div>

            {/* Lista de Tarefas */}
            <div className="task-list">
              <h2>Tarefas do Dia</h2>
              <ul>
                <li>Atualizar estoque de produtos</li>
                <li>Verificar pedidos pendentes</li>
                <li>Cadastrar novo funcionário</li>
              </ul>
            </div>

            {/* Lista de Pedidos Pendentes */}
            <div className="pending-orders">
              <h2>Pedidos Pendentes</h2>
              <ul>
                {pedidosPendentes.map((pedido) => (
                  <li key={pedido.id} className="pedido-item">
                    <p><strong>ID:</strong> {pedido.id}</p>
                    <p><strong>Cliente:</strong> {pedido.usuario}</p>
                    <p><strong>Endereço:</strong> {pedido.endereco}</p>
                    <p><strong>Status:</strong> {pedido.status}</p>
                    <input
                      type="text"
                      placeholder="Insira o código"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          finalizarPedido(pedido.id, e.target.value);
                          e.target.value = ''; // Limpar o campo após finalizar
                        }
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}

        <Outlet />
      </main>
    </div>
  );
};

export default Funcionarios;